import React, { useState } from 'react';
import styles from './Buttons.module.css';
import Langs from '../../app/lang/langs';


export default function TextButton(props) {
    return <button onClick={props.handleClick}
        className={styles.textBtn}>
        <Langs str={props.label} />
    </button>
}